import React from 'react';
import { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [selectedLang, setSelectedLang] = useState(
    localStorage.getItem('preferredLang') || 'en-US'
  );

  const setLanguage = (lang) => {
    setSelectedLang(lang);
    localStorage.setItem('preferredLang', lang);
  };

  return (
    <LanguageContext.Provider value={{ selectedLang, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  return useContext(LanguageContext);
};
